module.exports = __webpack_public_path__ + "static/media/ZAPTalent-Icono-9.4fb15866.svg";